var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSortListAsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10c0 .3-.1.5-.3.7-.4.4-1 .4-1.4 0L12 7.4l-3.3 3.3c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l4-4c.4-.4 1-.4 1.4 0l4 4c.2.2.3.4.3.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15c0-.3.1-.5.3-.7.4-.4 1-.4 1.4 0l3.3 3.3 3.3-3.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-4 4c-.4.4-1 .4-1.4 0l-4-4c-.2-.2-.3-.4-.3-.7z",
    opacity: 0.25
  })));
}

export default SvgIconSortListAsc;